import {
	Component,
	HostListener,
	OnInit,
	TemplateRef,
	Type
} from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CookieService } from 'ngx-cookie-service';
import { FacadeService } from 'src/app/core/services/facade.service';

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
	refreshModalRef: BsModalRef;
	isRefreshingToken: boolean;

	isMobile = false;
	screenWidth: number;

	tabs: any[] = [
		{
			name: 'Profil',
			path: '/espace-perso/profil',
			parentPath: '/espace-perso/profil',
			icon: 'bi-person-fill'
		},
		{
			name: 'Sécurité',
			path: '/espace-perso/securite',
			parentPath: '/espace-perso/securite',
			icon: 'bi-lock-fill'
		}
	];

	constructor(private router: Router, private facade: FacadeService) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	onActivate(event) {
		window.scroll(0, 0);
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;
	}

	scrollTop() {
		window.scroll(0, 0);
	}

	get pageSelector() {
		return this.router;
	}

	isRouterActive(parentPath: string) {
		return this.router.isActive(parentPath, false);
	}
}
